import React from 'react';
import { DotsStyles as S } from './Dots.styles';
const Dots = ({ activeIndex, itemCount, setActiveIndex, useAltTheme }) => {
    const containerRef = React.useRef(null);
    React.useEffect(() => {
        const container = containerRef.current;
        if (!container)
            return;
        const activeDot = container.querySelector('[aria-current="true"]');
        if (!activeDot)
            return;
        const activeDotOffset = activeDot.offsetLeft - container.offsetLeft;
        container.scrollTo({
            left: activeDotOffset,
            behavior: 'smooth',
        });
    }, [activeIndex]);
    return (React.createElement(S.Dots, { "data-use-alt-theme": useAltTheme },
        React.createElement(S.DotsInner, { ref: containerRef }, Array.from(Array(itemCount)).map((_, index) => {
            const isInteractive = setActiveIndex !== undefined;
            const interactiveAttrs = isInteractive
                ? {
                    role: 'button',
                    'aria-current': index == activeIndex,
                    'aria-label': `${index + 1} of ${itemCount}`,
                }
                : {
                    'data-active': index == activeIndex,
                };
            return (React.createElement(S.Dot, { key: `dot-${index}`, ...interactiveAttrs, onClick: () => {
                    if (isInteractive) {
                        setActiveIndex(index);
                    }
                } }));
        }))));
};
export default Dots;
